import { Report, ReportApi, ReportOverlay } from '@api/model';
import { DefaultHttpService } from 'src/js/api/services/HttpService';

class ReportsService {

  readonly reportingAPI  = new ReportApi(new DefaultHttpService());

  public getAllFromAngel(): Promise<Array<Report>> {
    return this.reportingAPI.getAllFromAngel();
  }

  public getOverlaysFromAngel(): Promise<Array<ReportOverlay>> {
    return this.reportingAPI.getOverlaysFromAngel();
  }
}

export default new ReportsService();